var arabam;
(function (arabam) {
    var ShowHideListingService = /** @class */ (function () {
        function ShowHideListingService($window) {
            this.$window = $window;
        }
        ShowHideListingService.prototype.init = function () {
            var self = this;
            return self.isBrowserCompatible();
        };
        ShowHideListingService.prototype.markAsHidden = function (advertId) {
            try {
                var hiddenListings = JSON.parse(localStorage.getItem("hiddenListings")) || [];
                hiddenListings.push(advertId);
                localStorage.setItem("hiddenListings", JSON.stringify(hiddenListings));
                return true;
            }
            catch (e) {
                return false;
            }
        };
        ShowHideListingService.prototype.removeAsHidden = function (advertId) {
            try {
                var hiddenListings = JSON.parse(localStorage.getItem("hiddenListings")) || [];
                hiddenListings.splice(hiddenListings.indexOf(advertId), 1);
                localStorage.setItem("hiddenListings", JSON.stringify(hiddenListings));
                return true;
            }
            catch (e) {
                return false;
            }
        };
        ShowHideListingService.prototype.isBrowserCompatible = function () {
            var self = this;
            var result = false;
            result = self.storageAvailable("localStorage");
            if (!result) {
                result = self.storageAvailable("sessionStorage");
            }
            return result;
        };
        ShowHideListingService.prototype.toggle = function (advertId) {
            try {
                if (this.isHidden(advertId)) {
                    return this.removeAsHidden(advertId);
                }
                else {
                    return this.markAsHidden(advertId);
                }
            }
            catch (e) {
                return false;
            }
        };
        ShowHideListingService.prototype.isHidden = function (advertId) {
            try {
                var hiddenListings = JSON.parse(localStorage.getItem("hiddenListings")) || [];
                if (hiddenListings.indexOf(advertId) > -1) {
                    return true;
                }
                else {
                    return false;
                }
            }
            catch (error) {
                return false;
            }
        };
        /**
         * storage tipi mevcut mu
         * @param type
         */
        ShowHideListingService.prototype.storageAvailable = function (type) {
            try {
                var storage = this.$window[type];
                var x = "__storage_test__";
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            }
            catch (e) {
                return false;
            }
        };
        ShowHideListingService.$inject = ["$window"];
        return ShowHideListingService;
    }());
    arabam.ShowHideListingService = ShowHideListingService;
    angular
        .module("arabam")
        .service("ShowHideListingService", ShowHideListingService);
})(arabam || (arabam = {}));
